"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formatters = require("../../utilities/formatters");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var MetaDataFooter = function MetaDataFooter(_ref) {
  var idLabel = _ref.idLabel,
    id = _ref.id,
    createdDate = _ref.createdDate,
    lastModifiedDate = _ref.lastModifiedDate,
    style = _ref.style;
  var prefix = idLabel || "ID";
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: "meta-data-footer",
    style: style
  }, id && /*#__PURE__*/_react["default"].createElement("div", null, prefix, ": ", id), createdDate && /*#__PURE__*/_react["default"].createElement("div", null, "Created date: ", (0, _formatters.dateTimeUk)(createdDate)), lastModifiedDate && /*#__PURE__*/_react["default"].createElement("div", null, "Last modified: ", (0, _formatters.dateTimeUk)(lastModifiedDate)));
};
var _default = MetaDataFooter;
exports["default"] = _default;
MetaDataFooter.propTypes = {
  id: _propTypes["default"].string,
  idLabel: _propTypes["default"].string,
  createdDate: _propTypes["default"].string,
  lastModifiedDate: _propTypes["default"].string,
  style: _propTypes["default"].object // standard react component style object
};